import { render, staticRenderFns } from "./MiniSalesOrders.vue?vue&type=template&id=749b06ed&scoped=true"
import script from "./MiniSalesOrders.vue?vue&type=script&lang=js"
export * from "./MiniSalesOrders.vue?vue&type=script&lang=js"
import style0 from "./MiniSalesOrders.vue?vue&type=style&index=0&id=749b06ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b06ed",
  null
  
)

export default component.exports